/* unplugin-vue-components disabled */import { render } from "./BeneficiaryToOwnerUpgradePage.vue?vue&type=template&id=317c5605"
import script from "./BeneficiaryToOwnerUpgradePage.vue?vue&type=script&lang=js"
export * from "./BeneficiaryToOwnerUpgradePage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__